import { SectionTitle } from '../SectionTitle';
import { HomePaths, PathsForExternal } from '@/modules/Paths';
import { QRButton } from 'app/[locale]/(homepage)/(home)/recording/components/QRButton';
import { useAttentionTracker } from 'app/[locale]/hooks/useAttentionTracker';
import { useTranslate } from 'app/[locale]/hooks/useTranslate';

export const AppSupportSection = (): JSX.Element => {
  const { t } = useTranslate();
  const { ref } = useAttentionTracker({ sectionName: 'main_app_support' });

  return (
    <section className="space-y-10 max-w-homepage md:pt-[60px] px-4 md:px-10" ref={ref}>
      <SectionTitle
        title={t.home.MAIN_APP_SUPPORT_TITLE}
        description={t.home.MAIN_APP_SUPPORT_DESC}
        linkText={t.home.MAIN_APP_SUPPORT_LINK}
        href={HomePaths.Recording}
      />
      <div className="flex justify-center gap-2 flex-wrap md:gap-5">
        <QRButton
          title="Google Play"
          icon="/callabo/store/google_play.svg"
          qrCodeImage="/callabo/store/qr_google.png"
          href={PathsForExternal.GooglePlayStore}
        />
        <QRButton
          title="App Store"
          icon="/callabo/store/apple.svg"
          qrCodeImage="/callabo/store/qr_apple.png"
          href={PathsForExternal.AppleAppStore}
        />
      </div>
    </section>
  );
};
